var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNew = function SvgNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5H9v4H5v2h4v4h2v-4h4V9h-4zm-1-5a10 10 0 1 0 10 10A10.029 10.029 0 0 0 10 0zm0 18a8 8 0 1 1 8-8 8.024 8.024 0 0 1-8 8z",
    fill: "currentColor"
  })));
};
export default SvgNew;